/*
 * @Author: 张玉婷
 * @Date: 2022-03-22 10:37:01
 * @LastEditTime: 2023-12-26 17:00:38
 * @LastEditors: Please set LastEditors
 * @Description:
 * @FilePath: \air_version_2\src\configs\mapConfig.ts
 */
export const mapIp = 'https://t1.tianditu.gov.cn';
// export const token = 'b2b3ad1e24481578049deffdd621cd1f';
export const token = 'e52074d314dd510386d8072f21fbf78f';
// 服务负载子域
export const subdomains = [
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
];

// wms服务地址
export const wmsUrl = 'http://52.83.170.95:18086/geoserver/air/wms';
export const regionBorder = `https://air.piesat.cn/geoserver/fire/wfs?service=WFS&request=GetFeature&version=1.1.0&typename=fire%3Aprovince&outputFormat=json&cql_filter=\${query}`;

export const layers = {
  img: { label: '影像图', value: ['img_w', 'cia_w',], },
  terrain: { label: '地形图', value: ['ter_w', 'cta_w',], },
  vector: { label: '矢量图', value: ['vec_w', 'cva_w',], },
};

// 地图界面产品列表
export const mapProductLists = [
  {
    label: '卫星',
    type: 'satellite',
    chidren: [
      {
        label: 'AOD',
        type: 'aod',
      },
      {
        label: 'PM2.5',
        type: 'pm25',
      },
      {
        label: 'PM10',
        type: 'pm10',
      },
      {
        label: 'SO2',
        type: 'so2',
      },
      {
        label: 'NO2',
        type: 'no2',
      },
      {
        label: 'CO',
        type: 'co',
      },
      {
        label: 'O3',
        type: 'o3',
      },
    ],
  },
  {
    label: '站点',
    type: 'satellite',
    chidren: [
      {
        label: 'AQI',
        type: 'aqi',
      },
      {
        label: 'PM2.5',
        type: 'pm25',
      },
      {
        label: 'PM10',
        type: 'pm10',
      },
      {
        label: 'SO2',
        type: 'so2',
      },
      {
        label: 'NO2',
        type: 'no2',
      },
      {
        label: 'CO',
        type: 'co',
      },
      {
        label: 'O3',
        type: 'o3',
      },
    ],
  },
  {
    label: '雷达',
    type: 'radar',
  },
  {
    label: '气象',
    type: 'atmosphere',
    chidren: [
      {
        label: '气温',
        type: '',
      },
      {
        label: '气压',
        type: 'pressure',
      },
      {
        label: '湿度',
        type: 'humidity',
      },
      {
        label: '降水',
        type: 'rain',
      },
    ],
  },
];

/* eslint-disable  newline-after-var,comma-dangle  */
// 节点类型转组件名称
export const nodeTypeMap = new Map([
  ['pre', 'weather'],
  ['prs', 'weather'],
  ['rhu', 'weather'],
  ['tem', 'weather'],
  ['yard', 'camera'],
  ['park', 'camera'],
  ['repair', 'camera'],
  ['country', 'env'],
  ['province', 'env'],
  ['city', 'env'],
  ['micro', 'env'],
  ['moveTrack', 'env'],
  ['construction', 'construction'],
  ['cookingFume', 'cookingFume'],
  ['weather', 'weather'],
  ['company', 'company'],
]);
